import React, { useEffect, useState } from 'react'
import RequestResetPassword from './request-reset-password'
import ResetPasswordToken from './reset-password-with-token'
import { useRouter } from 'next/router'
import { useMeCustomer } from 'medusa-react'
import RouterUrl from '@constants/router.constant'
import AuthLayout from '@layouts/auth-layout'
import DescriptionText from '../description-text'
import { getQueryParam } from '@lib/util/get-query-param'

const ResetPassword = () => {
  const router = useRouter()
  const { customer, isLoading } = useMeCustomer()

  const [isToken, setIsToken] = useState<boolean | null>(null)
  const [emailUser, setEmailUser] = useState<string | undefined>(undefined)

  useEffect(() => {
    if (!isLoading && customer != null) {
      router.replace(RouterUrl.HOME.ROOT)
    }
  }, [isLoading, customer])

  useEffect(() => {
    const query = getQueryParam(router.asPath)

    if (query.get('token') != null) {
      setIsToken(true)
    } else {
      setIsToken(false)
    }

    if (query.get('email') != null) {
      setEmailUser(query.get('email') as string)
    }
  }, [router?.query?.token, router?.query?.email])

  return (
    <AuthLayout
      title="Reset password"
      description={
        <DescriptionText>
          {isToken === true
            ? 'Reset your password'
            : 'Please enter your email address in the box below to receive instructions to reset password'}
        </DescriptionText>
      }
    >
      {isToken === false && <RequestResetPassword />}
      {isToken === true && (
        <ResetPasswordToken
          token={(router?.query?.token as string) ?? ''}
          emailUser={emailUser}
        />
      )}
    </AuthLayout>
  )
}

export default ResetPassword
